import React, { useState, useEffect, useMemo } from 'react';
import { Header } from '../components/Header';
import { Footer } from '../components/Footer';
import { SEO } from '../components/SEO';
import { StructuredData } from '../components/StructuredData';

const DisclaimerPage = () => {
  const [isVisible, setIsVisible] = useState(false);

  // Scroll to top on component mount
  useEffect(() => {
    window.scrollTo(0, 0);
    // Trigger header animation
    const timer = setTimeout(() => setIsVisible(true), 300);
    return () => clearTimeout(timer);
  }, []);

  const structuredData = useMemo(() => ({
    "name": "Disclaimer",
    "description": "Legal disclaimer and disclosures for Savi Investing Private Limited",
    "url": "https://saviinvesting.in/disclaimer"
  }), []);

  return (
    <div className="min-h-screen flex flex-col">
      <SEO 
        title="Disclaimer | Savi Investing"
        description="Savi Investing is not a SEBI-registered firm. We do not offer any investment or trading advice, and publish content strictly for informative purpose."
      />
      <StructuredData 
        type="WebPage"
        data={structuredData}
      />
      <Header />
      
      <main className="flex-grow pt-24">
        {/* Page Header */}
        <section className="bg-[#29367A] text-white py-24">
          <div className="w-full max-w-7xl mx-auto px-8">
            <h1 
              className={`text-5xl font-bold text-center transition-all duration-1000 transform ${
                isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-10'
              }`}
            >
              Disclaimer
            </h1>
          </div>
        </section>

        {/* Disclaimer Content */}
        <section className="py-16 bg-white">
          <div className="w-full max-w-5xl mx-auto px-8">
            <p className="text-lg text-gray-700 leading-relaxed mb-6">
              Savi Investing Pvt. Ltd. is not a SEBI-registered entity. The company neither provides any kind of investment advice, nor is into making any specific trade calls. It does not offer any investment-related services. Everything published by the company, online or offline, is solely for the purpose of educating and informing investors and capital market stakeholders, about the merits of having a disciplined, value-driven approach to Investing. The company only operates and manages its proprietary portfolio of equities that is meant for long-term wealth creation, while also taking trading positions in equities, commodities and other derivative instruments for short-term, liquid earnings.
            </p>
            
            <p className="text-lg text-gray-700 leading-relaxed">
              The company, therefore, assumes no responsibility for any kind of financial loss or damage that occurs to any person or entity, either directly or indirectly as a result of following and/or engaging with the company's online and offline publications. Please be advised to conduct your own due diligence and research before investing or taking trades in any of the listed financial securities.
            </p>
          </div>
        </section>
      </main>

      <Footer />
    </div>
  );
};

export default DisclaimerPage;
